import { useQuery } from '@tanstack/react-query';
import { get } from './api';
import API_ROUTES from './routes';

interface IConsoleSDK {
	projectId: string;
}

const getConsoleProject = async () => {
	const res = await get<IConsoleSDK>(API_ROUTES.sdkConfig);
	return res.data.projectId;
};

export const useConsoleProjectId = () =>
	useQuery(['console_project_id'], getConsoleProject, {
		staleTime: Infinity
	});
